import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/activities.js";
import "@ui5/webcomponents-icons/dist/appointment-2.js";
import "@ui5/webcomponents-icons/dist/bar-chart.js";
import "@ui5/webcomponents-icons/dist/collections-management.js";
import "@ui5/webcomponents-icons/dist/contacts.js";
import "@ui5/webcomponents-icons/dist/crm-service-manager.js";
import "@ui5/webcomponents-icons/dist/customer.js";
import "@ui5/webcomponents-icons/dist/kpi-corporate-performance.js";
import "@ui5/webcomponents-icons/dist/lead.js";
import "@ui5/webcomponents-icons/dist/locate-me.js";
import "@ui5/webcomponents-icons/dist/meeting-room.js";
import "@ui5/webcomponents-icons/dist/opportunity.js";
import "@ui5/webcomponents-icons/dist/pipeline-analysis.js";
import "@ui5/webcomponents-icons/dist/private.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/target-group.js";
import "@ui5/webcomponents-icons/dist/visits.js";

import { crmPermissions, crmSettingsGroup } from "./permissions";

/** CRM entries of the navigation registry (group `crm`, docs/contracts/crm.md). */
export const crmNavigation: readonly NavigationEntry[] = [
  { key: "crm.leads", labelKey: "nav.crmLeads", icon: "lead", path: "/crm/leads", permission: crmPermissions.leadView },
  {
    key: "crm.accounts",
    labelKey: "nav.crmAccounts",
    icon: "customer",
    path: "/crm/accounts",
    permission: crmPermissions.accountView,
  },
  {
    key: "crm.contacts",
    labelKey: "nav.crmContacts",
    icon: "contacts",
    path: "/crm/contacts",
    permission: crmPermissions.contactView,
  },
  {
    key: "crm.pipeline",
    labelKey: "nav.crmPipeline",
    icon: "pipeline-analysis",
    path: "/crm/pipeline",
    permission: crmPermissions.opportunityView,
  },
  {
    key: "crm.opportunities",
    labelKey: "nav.crmOpportunities",
    icon: "opportunity",
    path: "/crm/opportunities",
    permission: crmPermissions.opportunityView,
  },
  {
    key: "crm.activities",
    labelKey: "nav.crmActivities",
    icon: "activities",
    path: "/crm/activities",
    permission: crmPermissions.activityView,
  },
  {
    key: "crm.visits",
    subGroup: "fieldService",
    labelKey: "nav.crmVisits",
    icon: "visits",
    path: "/crm/visits",
    permission: crmPermissions.visitView,
  },
  {
    key: "crm.checkin",
    subGroup: "fieldService",
    labelKey: "nav.crmCheckIn",
    icon: "locate-me",
    path: "/crm/check-in",
    permission: crmPermissions.visitCreate,
  },
  {
    key: "crm.calendar",
    labelKey: "nav.crmCalendar",
    icon: "appointment-2",
    path: "/crm/calendar",
    permission: crmPermissions.appointmentView,
  },
  {
    key: "crm.resources",
    subGroup: "setup",
    labelKey: "nav.crmResources",
    icon: "meeting-room",
    path: "/crm/resources",
    permission: crmPermissions.resourceView,
  },
  {
    key: "crm.collections",
    subGroup: "fieldService",
    labelKey: "nav.crmCollections",
    icon: "collections-management",
    path: "/crm/collections",
    permission: crmPermissions.collectionView,
  },
  {
    key: "crm.cases",
    subGroup: "fieldService",
    labelKey: "nav.crmCases",
    icon: "crm-service-manager",
    path: "/crm/cases",
    permission: crmPermissions.caseView,
  },
  {
    key: "crm.targets",
    subGroup: "fieldService",
    labelKey: "nav.crmTargets",
    icon: "kpi-corporate-performance",
    path: "/crm/targets",
    permission: crmPermissions.targetView,
  },
  {
    key: "crm.segments",
    subGroup: "analysis",
    labelKey: "nav.crmSegments",
    icon: "target-group",
    path: "/crm/segments",
    permission: crmPermissions.segmentView,
  },
  {
    key: "crm.reports",
    subGroup: "analysis",
    labelKey: "nav.crmReports",
    icon: "bar-chart",
    path: "/crm/reports",
    permission: crmPermissions.reportView,
  },
  {
    key: "crm.privacy",
    subGroup: "setup",
    labelKey: "nav.crmPrivacy",
    icon: "private",
    path: "/crm/privacy",
    permission: crmPermissions.privacyView,
  },
  {
    key: "crm.setup",
    subGroup: "setup",
    labelKey: "nav.crmSetup",
    icon: "settings",
    path: "/crm/setup",
    permission: crmPermissions.setupView,
  },
  {
    key: "crm.settings",
    subGroup: "setup",
    labelKey: "nav.crmSettings",
    icon: "settings",
    path: `/platform/settings/${crmSettingsGroup}`,
    permission: crmPermissions.setupView,
  },
];
